import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { FunctionComponent } from 'react';
import { DiscordIcon } from 'src/components/icons/DiscordIcon';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WalletIcon from 'src/components/icons/WalletIcon';

export type LoginMethodType =
  | 'discord'
  | 'twitter'
  | 'google'
  | 'phone'
  | 'email'
  | 'wallet';

export const LoginMethods: {
  [announcementType in LoginMethodType]: {
    icon: FunctionComponent<SvgIconProps>;
    continueWithMessage?: string;
  };
} = {
  discord: {
    icon: DiscordIcon,
  },
  twitter: {
    icon: TwitterIcon,
  },
  google: {
    icon: GoogleIcon,
  },
  phone: {
    icon: LocalPhoneOutlinedIcon,
  },
  email: {
    icon: EmailOutlinedIcon,
  },
  wallet: {
    icon: WalletIcon,
    continueWithMessage: 'Connect wallet',
  },
};
